$(document).ready(function() {
  $('.cc-accordion-item summary').click(function() {
    var parentDetails = $(this).parent();

    // Toggle the 'active' class on the clicked summary and remove it from siblings
    parentDetails.toggleClass('active').siblings().removeClass('active');

    // Check if the 'active' class is present
    if (parentDetails.hasClass('active')) {
      // If 'active' class is present, add the 'open' attribute
      parentDetails.attr('open', true);
    } else {
      // If 'active' class is removed, remove the 'open' attribute
      parentDetails.removeAttr('open');
    }
  });
});